module.exports = __webpack_public_path__ + "static/media/bck-login.34671f71.svg";